


<template>
     <!-- box Preview -->
      <div class="py-1 ">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header pb-0">
              
                <div class="align-items-center">
                  <p class="mb-0 text-lg text-center text-black">
                    {{ currentMessages.InvoicePreview }} </p>
                  <p class="mb-0 text-md text-center text-black">
                  {{ currentMessages.InvoicePreviewReceiptNo }} :{{ receiptsCode }} 
                  </p>
                  <p class="mb-0 text-md text-center text-black">
                  {{ currentMessages.InvoicePreviewStoreNo }}  : {{ storeNumber }} 
                  </p>
                </div>
              </div>

      
              <div class="card-body mt-1">
                <p class="mb-0 text-md text-left text-black">
                {{ currentMessages.InvoicePreviewETaxInformation }}
                </p>
                <hr class="horizontal dark" />
              
              

                <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0">  {{ currentMessages.InvoicePreviewPersonType }} </p>
                      <p class="text-normal text-black"> {{ displayPersonType }} </p>
                    </div>
                  </div>
                 
 

             

                  <div class="row mt-3">
                    <div class="col-md-12">
                      <p v-if="receiptStore.selectedType === 'TXID'" class="mb-0">  {{ currentMessages.InvoiceFirstNameType2 }} </p>
                      <p v-else="receiptStore.selectedType === 'NIDN'" class="mb-0">  {{ currentMessages.InvoiceFirstName }} </p>
                      <p class="text-normal text-black"> {{ fullName }}  </p>
                    </div>
                  </div>

                  <div class="row mt-3" v-if="receiptStore.selectedType === 'NIDN'">
                    <div class="col-md-12">
                      <p class="mb-0">  {{ currentMessages.InvoiceSurname }} </p>
                      <p class="text-normal text-black"> {{ surName }}  </p>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0"> 
                         <!-- {{ currentMessages.InvoiceTaxID }} -->
                          <p v-if="receiptStore.selectedType === 'TXID'" class="mb-0">  {{ currentMessages.InvoiceTaxIDType2 }} </p>
                      <p v-else="receiptStore.selectedType === 'NIDN'" class="mb-0">  {{ currentMessages.InvoiceTaxID }} </p>
                        
                        </p>
                      <p class="text-normal text-black"> {{ taxID }} </p>
                    </div>
                  </div>

                   <div  v-if="receiptStore.selectedType === 'TXID'" class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0">  {{ currentMessages.InvoiceBranchCode }} </p>
                      <p class="text-normal text-black"> {{ branchCode }} </p>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-12">
                      <p class="mb-0">  {{ currentMessages.InvoiceCountry }} </p>
                      <p class="text-normal text-black"> TH </p>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-12">
                   
                        <p v-if="receiptStore.selectedType === 'TXID'" class="mb-0">  {{ currentMessages.InvoicePostCodePrvType2 }} </p>
                      <p v-else="receiptStore.selectedType === 'NIDN'" class="mb-0">  {{ currentMessages.InvoicePostCodePrv }} </p>
                      <p class="text-normal text-black"> {{ postCode }} </p>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-md-12">

                      <p v-if="receiptStore.selectedType === 'TXID'" class="mb-0">  {{ currentMessages.InvoiceType2Address1 }} </p>
                      <p v-else="receiptStore.selectedType === 'NIDN'" class="mb-0">  {{ currentMessages.InvoiceAddress1 }} </p>

                      <!-- <p class="mb-0">  {{ currentMessages.InvoiceAddress1 }} </p> -->
                      <p class="text-normal text-black"> {{ customerAddress }}  </p>
                    </div>
                  </div>


                  <div class="row mt-3">
                    <div class="col-md-12">
                      <!-- <p class="mb-0">  {{ currentMessages.InvoiceAddress2 }} </p> -->
                      <p v-if="receiptStore.selectedType === 'TXID'" class="mb-0">  {{ currentMessages.InvoiceType2Address2 }} </p>
                      <p v-else="receiptStore.selectedType === 'NIDN'" class="mb-0">  {{ currentMessages.InvoiceAddress2 }} </p>
                      <p class="text-normal text-black"> {{ customerAddress_2 }}  </p>
                    </div>
                  </div>


                  <div class="row mt-3">
                    <div class="col-md-12">
                       <p v-if="receiptStore.selectedType === 'TXID'" class="mb-0">  {{ currentMessages.InvoiceMobilePhonePrvType2 }} </p>
                      <p v-else="receiptStore.selectedType === 'NIDN'" class="mb-0">  {{ currentMessages.InvoiceMobilePhonePrv }} </p>
                      <!-- <p class="mb-0">  {{ currentMessages.InvoiceMobilePhone }} </p> -->
                      <p class="text-normal text-black"> {{ phoneNumber }}  </p>
                    </div>
                  </div>   
                <!-- <hr class="horizontal dark" /> -->
            
              </div>
            </div>
          </div>
          
        </div>
     </div>
     <!-- END box Preview -->

      <!-- ListItem -->

      <div class="py-1 mt-2">
        <div class="row">
          <div class="col-md-12">
            <div class="card">


              <div class="card-body mt-1">
                <p class="mb-0 text-md text-left text-black">
                {{ currentMessages.PurchaseDetails }}  
                </p>
                <hr class="end-box" />
              
              

                  <div class="row mt-3">
                    <div class="col-md-12">

                         <table style="width: 100%;">
                      <thead>
                        <tr>
                          <td class="text-left" style="color:black;font-size:16px;"> {{ currentMessages.PurchaseDetailsItem }}</td>
                          <td class="text-center"  style="color:black;font-size:16px;">{{ currentMessages.PurchaseDetailsQTY }}</td>
                          <td class="text-left"  style="color:black;font-size:16px;">{{ currentMessages.PurchaseDetailsAmount }}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-if="purchaseDetails.length > 0">
                          <tr v-for="(detail, index) in purchaseDetails" :key="detail.item + index">
                            <td class="text-left"  style="color:black;font-size:14px;">{{ detail.item }}</td>
                            <td class="text-center" style="color:black;font-size:14px;">{{ detail.qty }}</td>
                            <td class="text-left" style="color:black;font-size:14px;">{{ detail.amount ? detail.amount.toLocaleString() : '0' }}</td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="3" class="text-center text-muted">
                            {{ currentMessages.NoPurchaseDetailsFound || ' - ' }}
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2" class="text-right"><strong style="color:black;">Total</strong></td>
                         <td class="text-left"><strong style="color:black;">{{ totalAmount.toLocaleString() }}</strong></td>

                        </tr>
                      </tbody>
                    </table>
                  
                    
                    </div>
                  </div>



                
              </div>
            </div>
          </div>
          
        </div>
      </div>

         <!-- END ListItem-->


      <div class="row mb-5 mt-2">
        <span class="text-danger  mb-2"> {{ currentMessages.PurchaseDetailsReIssue  }}</span>
          <div class="col-md-6">
              <GlobalButtonPrv @click="handleClickEdit">
                {{ currentMessages.ButtonEdit }}  <i class="fa fa-pencil" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>

              </GlobalButtonPrv>
          </div>
          <div class="col-md-6">
            <GlobalButtonNext  :disabled="isSubmitting" @click="handleClickNextPage">
                {{ currentMessages.ButtonSend }}  <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
            </GlobalButtonNext>
        </div>
      </div>
      <br>
     <PopupModal
      :visible="isModalVisible"
      :title="modalTitle"
      :message="modalMessage"
      :subMessage="modalSubMessage"
      :closeText="'Close'"
      @close="isModalVisible = false"
    />

</template>







<script setup>

import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
//import { useRouter } from 'vue-router' 
import { useReceiptStoreEtax } from '@/store/useReceiptStoreEtax';
import { ref, computed, onMounted ,nextTick  } from "vue";
import { CreateInvoiceRequest , fetchGetOrderReceiptItem} from '/src/service-api/request-api-etax';

import PopupModal from "@/components/global/ModalAlert.vue"; 
const receiptStore = useReceiptStoreEtax();

const fullName = receiptStore.full_name;
const surName = receiptStore.last_name;
const taxID = receiptStore.tax_id;
const receiptsCode = receiptStore.receiptsCode;
const storeNumber = receiptStore.storeNumber;
const postCode = receiptStore.post_code;
const customerAddress = receiptStore.customer_address;
const customerAddress_2 = receiptStore.customer_address_2;
const phoneNumber = receiptStore.phone_number;
const branchCode = receiptStore.store_number;

import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);

const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);
const handleClickEdit = () => {
  emit('invoice'); 
};

const isSubmitting = ref(false);


const modalCases = {
  E101: "ErrorFullName",
  E102: "ErrorTaxID",
  E103: "ErrorBranchNo",
  E104: "ErrorEmail",
  E105: "ErrorPhone",
  E1052: "ErrorPhoneType2",
  E106: "ErrorPostCode",
  E107: "ErrorAddress1",
  E108: "ErrorAddress2"
};


const modalTitle = ref('');
const modalMessage = ref('');
const modalSubMessage = ref('');
const isModalVisible = ref(false);

const showModalCase = (code) => {

  const messageKey = modalCases[code] || "ErrorDefault";

  modalTitle.value = currentMessages.value.ErrorTitle;

  modalMessage.value =
    currentMessages.value[messageKey] || "Unknown error";

  modalSubMessage.value = '';

  isModalVisible.value = true;
};


const handleClickNextPage = async () => {

  if (isSubmitting.value) return; // ป้องกันกดซ้ำ
  isSubmitting.value = true;
  try {
   const payload = {
      receipts_code: receiptStore.receiptsCode,
      entity_type: receiptStore.selectedType,
      full_name: receiptStore.full_name,
      last_name: receiptStore.last_name,
      tax_id: receiptStore.tax_id,
      store_number: receiptStore.storeNumber,
      branch_no : branchCode,
      country: "TH",
      post_code: receiptStore.post_code,
      customer_address: receiptStore.customer_address,
      customer_address_2: receiptStore.customer_address_2,
      phone_number: receiptStore.phone_number,
      total_amount:  0,       // default 0
      email:receiptStore.email,
      total_vat: 0,             // default 0
      total_discount: 0,  
      is_interface: true,
      create_by: "user",
      update_by: "user"
    };


    const response = await CreateInvoiceRequest(payload);
      if (response && ['error', 'validation_error', 'fail'].includes(response.status)) {
      // console.log('Backend returned error:', response);
      // console.log('Response code:', response.code, 'Response message:', response.message);
      showModalCase(response.code);
      // switch(response.code) {
      //   case 'E101': showModalCase(1); break;
      //   case 'E102': showModalCase(2); break;
      //   case 'E103': showModalCase(3); break;
      //   case 'E104': showModalCase(4); break;
      //   case 'E105': showModalCase(4); break;
      //   case 'E106': showModalCase(4); break;
      //   case 'E107': showModalCase(4); break;
      //   case 'E108': showModalCase(4); break;
      //   default: {
      //     if (response.message) modalCases[0].message = response.message;
      //     showModalCase(0);
      //   }
      // }
    isSubmitting.value = false;
    return;
  }
    emit('submission'); 
    console.log('Success:', response);
  } 
  catch (err) {

  console.error('API Error:', err);

  let res = {};

  if (err.response?.data) {
    res = err.response.data;
  } 
  else if (typeof err === 'string') {
    try {
      const cleaned = err.replace(/null$/, '');
      res = JSON.parse(cleaned);
    } catch {
      res = { code: 'E000' };
    }
  }

  const code = res.code || 'E000';

  showModalCase(code);

  isSubmitting.value = false;
  }
  
  // catch (err) {
  //   console.error('เกิดข้อผิดพลาด:', err);
  // }
};

const purchaseDetails = ref([]);

onMounted(async () => {
  try {
    const res = await fetchGetOrderReceiptItem({
      receipt_code: receiptStore.receiptsCode,
      store_code: receiptStore.storeNumber,
    });

    if (res && res.fail_case === 0 && Array.isArray(res.items)) {
      purchaseDetails.value = res.items.map((item) => ({
        item: item.product_name,
        qty: item.qty,
        amount: item.net_sales,
      }));
    } else {
      console.warn('No items or fail_case != 0', res);
    }
  } catch (err) {
    console.error('Failed to fetch receipt items:', err);
  }
});




const displayPersonType = computed(() => {
  if (receiptStore.selectedType === 'TXID') {
    return currentMessages.value.InvoicePersonType2;
  } else if (receiptStore.selectedType === 'NIDN') {
    return currentMessages.value.InvoicePersonType1;
  }
  return '';
});


const totalAmount = computed(() => {
  const total = purchaseDetails.value.reduce((sum, detail) => {
    const amountNumber = Number(detail.amount) || 0;
    return sum + amountNumber;
  }, 0);
 // console.log('totalAmount computed:', total);
  return total;
});


</script>
<style scoped>
.radio-focused {
  border-color: orange !important;
  border-width: 2px;
  background-color: #ffffff;
}

.box-boder{
  border-radius: 10px!important;
}
.custom-radio-label {
  
    margin-bottom: 0;
}

 .input-border{
     
      border-radius: 10px!important;
    }
</style>